<template>
<div class="py-3">
  <transition name="fade">
    <div class="row m-0 align-items-center justify-content-center loadingItem" v-if="isProductLoading">
      <grid-loader :loading="isProductLoading" :size="loaderSize"></grid-loader>
    </div>
  </transition>
  <div class="row m-0" v-if="!isProductLoading">
    <div class="col-12 p-0" v-if="productToEdit">
      <app-product-edit :item="productToEdit" @close="updateProduct" @editimg="setImgToEdit"></app-product-edit>
    </div>
    <div class="col-12 p-0" v-else>
      <div class="row m-0">
        <div class="col-12 mb-3 category_menu">
          <div class="row m-0 category_menu_bg align-items-center">
            <div class="col-9 p-0">
              <div class="row m-0 h-100">
                <div class="col-12 p-0 pl-md-0">
                  <div class="row m-0 h-100">
                    <div class="col-2 col-md-3 h-100 pt-1 pl-2">
                      <search-menu @search="filterSearch"></search-menu>
                    </div>
                    <div class="col-10 col-md-9 h-100 px-0">
                      <div class="row m-0 h-100">
                        <div class="col-12 h-100 pl-0">
                          <div class="row flex-row flex-nowrap h-100 overflow_x" >
                            <category-item v-for="cat in activeCategories" :categoryItem="cat" :key="cat.id" @selectCategory="selectCategory" :selected="categoryFilter"></category-item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3 p-0 text-right">
              <button class="btn">
                <div class="row m-0 align-items-center justify-content-end h-100">
                  <div class="col-auto p-0 material-icons" @click="setToEdit({})">
                    add
                  </div>
                  <div class="col-auto pl-1 d-none d-md-block" @click="setToEdit({})">
                    Add New
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 p-0">
          <products-page v-for="(prod, key) in productsGroupedByCategory" :key="key" :categoryItem="key" :products="prod" :search="search" @setToEdit="setToEdit"></products-page>
        </div>
      </div>
    </div>
    <!-- <app-product-item v-for="prod in products" :item="prod" :key="prod.id" :displayList="displayList" @edit="setToEdit(prod)" @editImg="setImgToEdit(prod)"></app-product-item>
    <app-product-item-empty key="emptyProd" @add="setToEdit({})"></app-product-item-empty> -->
  </div>
  <!-- <div class="row m-0" v-if="productToEdit">
    <app-product-edit :item="productToEdit" :key="productToEdit.id" @close="updateProduct" @editimg="setImgToEdit"></app-product-edit>
  </div> -->
  <!-- <div class="row m-0" v-if="productImgToEdit">
    <app-product-img-edit :item="productImgToEdit" :key="productImgToEdit.id" @close="updateProduct"></app-product-img-edit>
  </div> -->
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Products',
  props: ['position'],
  components: {
    'app-product-edit': () => import('@/components/product/ProductEdit.vue'),
    // 'app-product-img-edit': () => import('@/components/product/ProductImgGallery.vue'),
    // 'app-product-item': () => import('@/components/product/ProductItem.vue'),
    // 'app-product-item-empty': () => import('@/components/product/ProductItemEmpty.vue'),
    GridLoader: () => import('vue-spinner/src/MoonLoader.vue'),
    'search-menu': () => import('@/components/common/Search.vue'),
    'category-item': () => import('@/components/CategoryMenuItem.vue'),
    'products-page': () => import('@/components/product/ProductPage.vue')
  },
  data () {
    return {
      loaderSize: '50px',
      displayList: false,
      productToEdit: null,
      productImgToEdit: null,
      search: '',
      categoryFilter: ''
    }
  },
  computed: {
    ...mapGetters(['products', 'isProductLoading', 'categories', 'productCategories']),
    productsGroupedByCategory () {
      let list = {}
      if (this.products.length < 4) {
        list.uncategorised = this.products
      } else if (this.products.length > 0) {
        list.uncategorised = this.products.filter((product) => typeof product.category === 'undefined')
        this.products.forEach((product) => {
          if (typeof product.category !== 'undefined') {
            if (typeof list[product.category] === 'undefined') {
              list[product.category] = []
            }
            var stringVal = product.category
            var newStringVal = stringVal.replace(/ /g, '')
            var category = {
              id: newStringVal,
              cat: stringVal
            }
            if (!product.isDeleted) {
              list[category.cat].push(product)
            }
          }
        })
      }
      return list
    },
    activeCategories () {
      var active = []
      for (var i = 0; i < this.categories.length; i++) {
        if (this.productCategories.indexOf(this.categories[i]) > -1) {
          var stringVal = this.categories[i]
          var newStringVal = stringVal.replace(/ /g, '')
          var category = {
            id: newStringVal,
            cat: stringVal
          }
          active.push(category)
        }
      }
      return active
    }
  },
  methods: {
    ...mapActions(['addItem', 'updateItem', 'addMessage']),
    changeDisplay (isList) {
      this.displayList = isList
    },
    setImgToEdit (prod) {
      this.productImgToEdit = prod
    },
    setToEdit (prod) {
      this.productToEdit = prod
    },
    updateProduct (prod) {
      if (prod) {
        if (prod.key) {
          this.updateItem(prod)
        } else {
          this.addItem(prod)
        }
      }
      this.setToEdit()
      this.setImgToEdit()
    },
    filterSearch (val) {
      this.search = val
    },
    selectCategory (val) {
      this.categoryFilter = val
    }
  }
}
</script>

<style>
.category_menu {
  height: 50px;
  position: sticky;
  top: 80px;
  z-index: 9;
}
.category_menu_bg {
  border-top: 1px solid var(--dark-color-off);
  border-bottom: 1px solid var(--dark-color-off);
  background-color: var(--light-color);
}
.border_top {
  border-top: 1px solid transparent;
}
.bg_color {
  border-top: 1px solid var(--dark-color-off);
  background-color: var(--light-color);
  /* margin-left: -1px; */
}
.dark-mode .bg_color {
  border-top: 1px solid var(--light-color-off);
  border-left: 1px solid var(--dark-color-off);
  background-color: var(--dark-color-off);
}
.overflow_x  {
  overflow-x: auto;
}
@media (min-width: 768px) {
  .category_menu {
    top: 60px;
  }
}
</style>
